import { BaseHTMLElement } from "../BaseHTMLElement";

export class Container extends BaseHTMLElement {
    constructor(className?: string) {
        super('div', className);
    }

    public addChild(child: BaseHTMLElement): this {
        this.element.appendChild(child.getElement());
        return this;
    }

    public addChildren(...children: BaseHTMLElement[]): this {
        children.forEach(child => this.addChild(child));
        return this;
    }
}
